import { httpUrl } from "./httpUrl";

// let baseUrl = `${httpUrl.host}/gy-apartment`;
// // let baseUrl = `${httpUrl.host}`;
// let baseUrl2 = `${httpUrl.host}/kj-gy-apartment`;
let baseUrl = `${httpUrl.host}/gy-finance`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 收费项管理——分页
  getPaymentItemPage: `${baseUrl}/paymentItem/getPage`,

  // 收费项管理——删除
  deletePaymentItemByCodes: `${baseUrl}/paymentItem/delete`,

  // 收费项管理——添加
  addPaymentItem: `${baseUrl}/paymentItem/add`,

  // 收费项管理——详情
  getPaymentItemByCode: `${baseUrl}/paymentItem/getByCode`,

  // 收费项管理——修改
  updatePaymentItem: `${baseUrl}/paymentItem/update`,

  // 获取收费项列表
  getPaymentItemList: `${baseUrl}/paymentItem/getList`,

  // 收费管理——分页
  getChargeBillPage: `${baseUrl}/chargeBill/getPage`,

  // 获取人员列表
  getPersonList: `${baseUrl2}/person/getList`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl2}/enterpriseInfo/getEnterpriseList`,

  // 收费管理——添加
  addChargeBill: `${baseUrl}/chargeBill/add`,

  //收费管理——导出
  exportCharge: `${baseUrl}/chargeBill/exportForCharge`,

  // 退款管理——分页
  getRefundManagementPage: `${baseUrl}/refundManagement/getPage`,

  // 获取已付款账单列表
  getChargeBillList: `${baseUrl}/chargeBill/getList`,

  //获取退款对象列表
  getChargeBillPayerList: `${baseUrl}/chargeBill/payerList`,

  //退款管理——添加
  addRefundBill: `${baseUrl}/refundManagement/add`,

  //退款管理——导出
  exportRefund: `${baseUrl}/refundManagement/export`,

  //退款管理——确认退款
  confirmRefundBill: `${baseUrl}/refundManagement/confirmRefund`,

  // 确认退款——详情
  getRefundManagementByCode: `${baseUrl}/refundManagement/getByCode`,

  // 住户退款——确认
  refundByCompany: `${baseUrl}/refundManagement/refundByCompany`,

  // 住户退款——查询退款住户
  getChargeBillEnterpriseList: `${baseUrl}/chargeBill/enterpriseList`,

  // 住户退款——查询关联账单
  getRelationBill: `${baseUrl}/refundManagement/getRelationBill`,

  // 住户退款——计算账单总金额
  getTotalAmount: `${baseUrl}/refundManagement/totalAmount`,
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/CustomPayment.js